import { get, put, del } from 'aws-amplify/api';
import {getErrorMessage} from "../stores/StoreUtilities";
import Logger from "../components/Logger";

class AuthAPI {

  getAlias = async (alias: string) => {
    try {
      const restOperation = get({ apiName: "AuthAPI", path: `/alias/${alias}` })
      const { body } = await restOperation.response
      const response = await body.json() as any
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("AuthAPI.getAlias error", message)
      throw new Error(message)
    }
  }

  putUser = async (username: string, params: any)=> {
    try {
      const init = {
        body: {
          UserAttributes: [
            {Name: "email_verified", Value: "true"}
          ]
        }
      }
      const restOperation = put({ apiName: "AuthAPI", path: `/user/${username}`, options: { body: init.body as any } })
      const { body: responseBody } = await restOperation.response
      const response = await responseBody.json() as any
      return response
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("AuthAPI.putUser error", message)
      throw new Error(message)
    }
  }

  deleteUser = async (username: string) => {
    try {
      const restOperation = del({ apiName: "AuthAPI", path: `/user/${username}` })
      await restOperation.response
      return
    } catch (err) {
      const message = getErrorMessage(err)
      Logger.error("AuthAPI.deleteUser error", message)
      throw new Error(message)
    }
  }

}
export default AuthAPI